module.exports = __webpack_public_path__ + "src/img/closeIcon.03fcfbab.svg";